"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 30: UNROM 512 (UNROM with 5-bit PRG bank select)
 * ------------------------------------------------------------------ */
// PRG ROM up to 512 KB (32 x 16 KB banks). The low bit selects the 16 KB
// window ($8000-$BFFF vs $C000-$FFFF), and 5 bits select which 16 KB bank
// within the selected window — but in practice most dumps use this as a 5-bit
// bank select into the whole 512 KB range, so we decode by address range and
// use all 5 bits as the bank number directly.

function register(Mappers) {
  Mappers[30] = function (nes) {
    this.nes = nes;
  };

  Mappers[30].prototype = new Mappers[0]();

  Mappers[30].prototype.irqClockRate = "none";

  Mappers[30].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank = 0;
  };

  Mappers[30].prototype.write = function (address, value) {
    if (address < 0x8000) {
      if (address >= 0x6000) {
        // WRAM if enabled (uncommon on UNROM boards)
      }
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // Low 4 bits of address select the register; bit 14 selects the window
    var isHighWindow = (address & 0x4000) !== 0;

    if (isHighWindow) {
      // $C000-$FFFF: 5-bit bank
      this.prgBank = value & 0x1f; // 5 bits for full 512 KB
      this.loadRomBank(this.prgBank, 0xc000);
    } else {
      // $8000-$BFFF: 5-bit bank
      this.prgBank = value & 0x1f;
      this.loadRomBank(this.prgBank, 0x8000);
    }

    // CHR ROM bank select (when present): bits 4-7 select 8 KB CHR bank
    var num8kBanks = this.nes.rom.header[5];
    if (num8kBanks && num8kBanks > 0) {
      var chr8kBank = (value >> 4) & 0x0f;
      var max8k = Math.min(num8kBanks, 16);
      chr8kBank = Math.min(chr8kBank, max8k - 1);
      this.load8kVromBank(chr8kBank * 2, 0x0000);
    }
  };

  Mappers[30].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("UNROM 512: Invalid ROM! Unable to load.");
    }
    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    // Power-on: first bank at $8000, second at $C000
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(
      this.nes.romCount >= 2 ? 1 % this.nes.romCount : 0,
      0xc000,
    );
    this.nes.cpu.requestIrq(this.nes.cpu.IRQ_RESET);
  };
}

module.exports = { register: register };
